import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import type { RoutePath } from 'state/router';

export function useNavigateTo(path: RoutePath) {
  const navigate = useNavigate();
  return useCallback(() => navigate(path), [path, navigate]);
}
